import { render, staticRenderFns } from "./VariantDialog.vue?vue&type=template&id=da7bcd94&"
import script from "./VariantDialog.vue?vue&type=script&lang=js&"
export * from "./VariantDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports